import { Divider } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { globalConst } from 'modules/global';

import AppDownSection from './app-down-section';
import MainFooter from './main-footer';

export default function Footer() {
  const { pathname } = useRouter();

  const hasProFooter = pathname.startsWith(globalConst.pageNames.PRO);
  const hasPremium = useAppSelector(state => state.user.premium);

  return (
    <footer className='mt-20'>
      {/* App Download Section */}
      {!hasPremium && !hasProFooter && <AppDownSection />}

      {/* Main Footer Section */}
      <MainFooter />

      {/* Copyright */}
      <div className="bg-gray-800 py-4 text-center text-sm text-gray-300">
        <Divider className="bg-gray-500" />
        <div className="container mx-auto px-4">
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <p>
            © 2025{' '}
            <Link href="https://softex.uz/" target="_blank" className="hover:text-blue-500">
              SOFTEX
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
